// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8a008f9f","239":"2e3d563e","455":"14a43762"}[chunkId] + ".chunk.js";
};